import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { Switch } from 'react-router';
import { connect } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { ToastContainer } from 'react-toastify';

// import createHistory from 'history/createBrowserHistory';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './App.scss';
import { RootState } from './models/RootState';

import AcceptTerms from './pages/AcceptTerms/AcceptTerms';
import MailVerificationAlert from './components/MailVerificationAlert/MailVerificationAlert';
import { fetchMailVerifiedSuccess, logout } from './store';
import ResetPassword from './pages/ResetPasswordPage/ResetPasswordPage';
import AccessRedirect from './pages/AccessRedirect/Accessredirect';
import { Button } from '@material-ui/core';
const Admin = lazy(() => import('./router/AdminRouter'));
const MainPage = lazy(() => import('./router/UserRouter'));
const Platform = lazy(() => import('./router/PlatFormAdminRouter'));
const LoginPage = lazy(() => import('./pages/Login/Login'));
type StateProps = {
  fetchMailVerifiedSuccess: (mailVerified: boolean) => void;
  logout: () => void;
  mailVerified: boolean;
  prefersDark: string;
  loggedIn: boolean;
};

const App: React.FC<StateProps> = (props) => {
  const [mvState] = useState<boolean>(null);
  const consoleOpen = useConsoleOpen();
  const [idleModal, setIdleModal] = useState<boolean>(false);
  const { logout, prefersDark, loggedIn } = props;
  const timeout = 1000 * 60 * 45;
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    const toggleTheme = (theme) => {
      if (theme === 'dark') {
        document.body.setAttribute('data-theme', 'dark');
      } else if (theme === 'light') {
        document.body.setAttribute('data-theme', 'light');
      } else if (theme === 'blue') {
        document.body.setAttribute('data-theme', 'blue');
      } else if (theme === 'green') {
        document.body.setAttribute('data-theme', 'green');
      } else if (theme === 'purple') {
        document.body.setAttribute('data-theme', 'purple');
      }
    };
    let systemDark = window.matchMedia(
      `(prefers-color-scheme: ${prefersDark})`
    );
    systemDark.addListener((e) => toggleTheme(prefersDark));
    let a = ['dark', 'light', 'blue', 'green', 'purple'];
    a.splice(a.indexOf(prefersDark), 1);
    document.body.classList.remove(...a);
    document.body.classList.toggle(prefersDark, true);
  }, [prefersDark]);

  // const handleOnIdle = () => {
  //   console.log('user is idle');
  //   if (loggedIn) {
  //     logout();
  //   }
  // };

  const handleClose = () => {
    console.log('user open devtools');
  };

  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => {
    if (loggedIn) {
      setIsIdle(true);
      setIdleModal(true);
    } else handleReset();
  };

  const closeIdleModal = () => {
    if (loggedIn) {
      setIsIdle(false);
      setIdleModal(false);
      logout();
    } else {
      handleReset();
      setIsIdle(false);
      setIdleModal(false);
    }
  };
  const ContinueActive = () => {
    if (loggedIn) {
      setIdleModal(false);
      setIsIdle(false);
    } else {
      setIsIdle(false);
      setIdleModal(false);
    }
  };
  const {
    reset,
    // pause,
    // resume,
  } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
  });

  const handleReset = () => reset();
  // const handlePause = () => pause();
  // const handleResume = () => resume();

  return (
    <>
      {!consoleOpen ? (
        <Suspense fallback={<div>Loading...</div>}>
          <BrowserRouter>
            <Switch>
              <Route path="/access_redirect" component={AccessRedirect} />
              <Route path="/login" component={LoginPage} />
              <Route path="/admin" component={Admin} />
              <Route path="/platform_admin" component={Platform} />
              <Route path="/terms-and-conditions" component={AcceptTerms} />
              <Route path="/reset-password" component={ResetPassword} />
              <Route path="/" component={MainPage} />
            </Switch>
            {mvState === false ? (
              <MailVerificationAlert message="Verify your email"></MailVerificationAlert>
            ) : null}
          </BrowserRouter>
        </Suspense>
      ) : null}

      <Dialog
        open={consoleOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
        className="dev-tools-msg-modal"
      >
        <DialogContent className="modal-content-ctn">
          <div className="dev-tools-warning-msg">
            {' '}
            Due to some inactivity or security reasons stop your website, please
            close the developer tool. Thank you for your support
          </div>
        </DialogContent>
      </Dialog>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Dialog
        open={idleModal}
        onClose={() => closeIdleModal()}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
        className="modal"
      >
        <div className="carw">
          <div className="arrow arrow-right">Page Expired</div>
        </div>
        <div className="modal-content">
          <div className="dev-tools-warning-msg">
            <div className="msg">
              <div className="alert">Time-Out Alert</div>{' '}
              <p className="dsc">
                {' '}
                You have been inactive for a long time your session is expired.
                Confirm to renew session.
              </p>
              <div className="dsc-btn">
                <Button onClick={() => ContinueActive()} className="btn">
                  Continue
                </Button>
                <Button onClick={() => closeIdleModal()} className="btn1">
                  Logout
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export const useConsoleOpen = () => {
  const [consoleOpen, setConsoleOpen] = useState(false);

  useEffect(() => {
    let checkStatus;
    var element = new Image();
    Object.defineProperty(element, 'id', {
      get: function () {
        checkStatus = true;
        throw new Error('Dev tools checker');
      },
    });

    requestAnimationFrame(function check() {
      setTimeout(() => {
        checkStatus = false;
        // Don't delete this console statements
        // if you want dev tools just comment this below two lines.

        if (process.env.REACT_APP_NODE_ENV !== 'development') {
          // console.clear();
          // console.dir(element);
        }

        setConsoleOpen(checkStatus);
        requestAnimationFrame(check);
      }, 1000);
    });
  });

  return consoleOpen;
};

const mapStateToProps = (state: RootState) => {
  return {
    mailVerified: state.auth.mailVerified,
    prefersDark: state.common.prefersDark,
    loggedIn: state.auth.loggedIn,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchMailVerifiedSuccess: (mailVerified: boolean) =>
      dispatch(fetchMailVerifiedSuccess(mailVerified)),
    logout: () => dispatch(logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
